import React, { useEffect, useState } from 'react';
import { Image, Text, View } from 'react-native';
import { TranslationView } from '@levelapp/softfabric-ui';
import Helpers from '../../../../../Common/Helpers/AmountHelpers';
import HexagonView from './components/hexagon/HexagonView';
import Project from "../../../../../Common/DTO/Project";
import { styles } from './PresentationViewStyle';
import { useWindowSizeContext } from "../../../../../Common/contexts/WindowSizeContext";

interface PresentationViewProps {
  project: Project;
}

export const PresentationView = ({ project }: PresentationViewProps) => {
  const { width, isMobile } = useWindowSizeContext();
  const [showProlongation, setShowProlongation] = useState(false);

  let headerImgUrl: string = project.projectImages.find(x => x.type === "HEADER_PICTURE")?.url || Helpers.getPropertyValue("HEADER_PICTURE", project.projectPropertyValues) || "";

  if (isMobile && project.code == 'clam') {
    headerImgUrl = 'https://beebondsstorage.blob.core.windows.net/files/clam/pictures/Clamart%20mobile.jpg';
  }

  if (isMobile) {
    headerImgUrl = project.projectImages.find(x => x.type === "HEADER_PICTURE_MOBILE")?.url || Helpers.getPropertyValue("HEADER_PICTURE_MOBILE", project.projectPropertyValues) || "";
    if (!headerImgUrl)
      headerImgUrl = project.projectImages.find(x => x.type === "HEADER_PICTURE")?.url || Helpers.getPropertyValue("HEADER_PICTURE", project.projectPropertyValues) || "";
  }

  const headerImgWidth = isMobile ? width < 400 ? width * 0.775 : width * 0.8125 : width * 0.885;

  const bubbleWidth = isMobile ? headerImgWidth * 0.33 : headerImgWidth * 0.175;
  const bubbleFontSize = isMobile ? 12 : 20;

  function getBackgroundColor() {
    switch (project.projectType.title) {
      case 'FINANCED':
        return '#F7A335';
      case 'STUDY':
        return '#C7597C';
      case 'FINANCING':
        return '#2A8A8D';
      case 'REFUNDED':
        return '#4FAFC8';
      case 'PREVIEW':
        return 'red';
      default:
        return '#FFFFFF'; // Couleur par défaut si aucune condition ne correspond
    }
  }

  useEffect(() => {
    const offerEndDate = project.offerEndDate;
    if (offerEndDate) {
      const [day, month, year] = offerEndDate.split("/").map(Number);
      const endDate = new Date(year, month - 1, day);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      if (endDate > today)
        setShowProlongation(false);
    }
  });

  return (
    <View style={styles.page}>
      {isMobile &&
        <Image source={{ uri: headerImgUrl }} style={[styles.imageSquare]} />
      }
      {!isMobile &&
        <Image source={{ uri: headerImgUrl }} style={[styles.image]} />
      }


      <View style={[styles.projectName, isMobile ? styles.projectNameTop : styles.projectNameLeft]}>
        <Text style={[styles.projectNameLeftText, { fontSize: isMobile ? 24 : 24 }]}>{project.projectName}</Text>
      </View>
      {!isMobile && project.code != "rwdm" &&
        <View style={styles.hexagonLeft}>
          <HexagonView project={project} isMobile={isMobile} />
        </View>
      }

      <>
        <View style={isMobile ? styles.imageBubbleLeftViewRow : styles.imageBubbleRightViewCol}>
          <View style={[styles.imageBubbleRightDown, { backgroundColor: getBackgroundColor(), width: bubbleWidth }]}>
            <TranslationView style={[styles.imageBubbleTextWhite, { fontSize: bubbleFontSize }]}>{project.projectType.title}</TranslationView>
          </View>
          <View style={{ height: 15 }} />
          {project.safetyTypeId == 2 &&
            <View style={[styles.imageBubbleRightDown, { width: bubbleWidth }]}>
              <TranslationView style={[styles.imageBubbleTextWhite, { fontSize: bubbleFontSize }]}>WITH_SAFETY</TranslationView>
            </View>
          }
            {project.code == 'rwdm' &&
            <View style={[styles.imageBubbleRightDown, { width: bubbleWidth }]}>
              <TranslationView style={[styles.imageBubbleTextWhite, { fontSize: bubbleFontSize }]}>APPEL_DON</TranslationView>
            </View>
          }
          {showProlongation &&
            <>
              <View style={{ height: 15 }} />
              <View style={[styles.imageBubbleRightDown, { width: bubbleWidth, backgroundColor: "#F25C1C" }]}>
                <TranslationView style={[styles.imageBubbleTextWhite, { fontSize: bubbleFontSize }]}>PROLONGATION</TranslationView>
              </View>
              <View style={{ height: 15 }} />
              {project.code != "yoga2" && project.code != "velo" &&
                <View style={[styles.imageBubbleRightDown, { width: bubbleWidth }]}>
                  <TranslationView style={[styles.imageBubbleTextWhite, { fontSize: bubbleFontSize }]}>WITH_SAFETY</TranslationView>
                </View>
              }
            </>
          }
        </View>
      </>

    </View >
  );
}

export default PresentationView;